import React, { useState, useEffect } from 'react';
import { userAPI, messageAPI } from '../services/api';
import UserList from '../components/UserList';
import ChatBox from '../components/ChatBox';
import './Chat.css';

const DEMO_USERS = [
  { id: 2, username: 'Alice Johnson', email: 'alice@demo.local', avatar: null },
  { id: 3, username: 'Bob Smith', email: 'bob@demo.local', avatar: null },
  { id: 4, username: 'Carol White', email: 'carol@demo.local', avatar: null }
];

const DEMO_MESSAGES = {
  2: [
    { id: 1, sender_id: 2, recipient_id: 1, content: 'Hey! How are you?', created_at: new Date(Date.now() - 300000).toISOString() },
    { id: 2, sender_id: 1, recipient_id: 2, content: 'Good! You?', created_at: new Date(Date.now() - 240000).toISOString() },
    { id: 3, sender_id: 2, recipient_id: 1, content: 'Doing great! Want to chat?', created_at: new Date(Date.now() - 180000).toISOString() }
  ],
  3: [
    { id: 4, sender_id: 3, recipient_id: 1, content: 'Hello there!', created_at: new Date(Date.now() - 120000).toISOString() }
  ],
  4: []
};

export default function Chat({ user, onLogout }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [demoMode, setDemoMode] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    if (selectedUser) {
      loadMessages();
    }
  }, [selectedUser]);

  const loadMessages = async () => {
    if (demoMode) {
      setMessages(DEMO_MESSAGES[selectedUser.id] || []);
      return;
    }
    try {
      const response = await messageAPI.getDirectMessages(selectedUser.id);
      setMessages(response.data);
    } catch (error) {
      console.error('Failed to load messages:', error);
      setDemoMode(true);
      setMessages(DEMO_MESSAGES[selectedUser.id] || []);
    }
  };

  const loadUsers = async () => {
    if (demoMode) {
      setUsers(DEMO_USERS);
      return;
    }
    try {
      const response = await userAPI.getAllUsers();
      setUsers(response.data);
    } catch (error) {
      console.error('Failed to load users:', error);
      setDemoMode(true);
      setUsers(DEMO_USERS);
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    setLoading(true);
    try {
      if (demoMode) {
        const msg = {
          id: Math.random(),
          sender_id: user.id,
          recipient_id: selectedUser.id,
          content: newMessage,
          created_at: new Date().toISOString()
        };
        setMessages([...messages, msg]);
        setNewMessage('');
      } else {
        await messageAPI.sendDirectMessage(selectedUser.id, newMessage);
        setNewMessage('');
        loadMessages();
      }
    } catch (error) {
      console.error('Failed to send message:', error);
      setDemoMode(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-sidebar">
        <div className="sidebar-header">
          <h2>💬 Chats {demoMode && '(Demo)'}</h2>
          <button className="logout-btn" onClick={onLogout}>Logout</button>
        </div>
        <UserList
          users={users}
          selectedUser={selectedUser}
          onSelectUser={setSelectedUser}
        />
      </div>
      <div className="chat-main">
        {selectedUser ? (
          <>
            <ChatBox
              user={selectedUser}
              messages={messages}
              currentUser={user}
            />
            <form className="message-form" onSubmit={handleSendMessage}>
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder={demoMode ? "Demo mode - messages don't persist" : "Type a message..."}
                disabled={loading}
              />
              <button type="submit" disabled={loading}>Send</button>
            </form>
          </>
        ) : (
          <div className="no-selection">
            <p>Select a user to start chatting</p>
            {demoMode && <p style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '10px' }}>Running in demo mode (no backend)</p>}
          </div>
        )}
      </div>
    </div>
  );
}
